import React from 'react'
import Banner  from '../components/Bannner'
import Services from '../components/Services'
import TabsSection from '../components/tabssec'
import Categories from '../components/Categories'
import Mainproduct from '../components/Mainproduct'
import ProductCard from '../components/product'
import About from '../components/about'
import CmsEditBar from '../components/cms/CmsEditBar'
import CmsEditableList from '../components/cms/CmsEditableList'
import { useCmsPage } from '../hooks/useCmsPage'

function Home() {
  const cms = useCmsPage('home')
  const services = cms.json('services', 'items', undefined)

  return (
    <div>
      <CmsEditBar editMode={cms.editMode} pageTitle="Home Page" />
      <Banner />
      <div className="container">
        <CmsEditableList editMode={cms.editMode} fieldKey="items" fields={["title", "subtitle"]} itemName="service box" label="Home service boxes" onSave={cms.updateField} sectionKey="services" value={services || []} />
      </div>
      <Services services={services} />
      <TabsSection />
      <Categories />
      <Mainproduct />
      <ProductCard />
      <About cms={cms} />
    </div>
  )
}

export default Home
